import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    fontFamily: 'Manrope',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: '0.01em',
    color: colors.textMediumContrast,
    backgroundColor: colors.white,
    boxShadow: '0 1px 15px 0 rgba(0, 0, 0, 0.15)',
    padding: 16,
  },
  arrow: {
    '&:before': {
      backgroundColor: colors.white,
    },
  },
});
